import React, { useContext } from 'react';
import usePageClassName from '../hooks/usePageClassName';
import useTranslation from '../hooks/useTranslation';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../toolkit/WithTitle';

type Props = {};

// TODO: get error type...

const ErrorPage: React.FC<Props> = () => {
  const { t } = useTranslation();
  usePageClassName('error-page');
  const { pages } = useContext(ConfigContext);

  const title = t('pageTitles.error');
  const Page = pages.error.component;
  return (
    <WithTitle title={title}>
      <Page />
    </WithTitle>
  );
};

export default ErrorPage;
